import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, EventEmitter, Output, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { DeviceLocationService } from '@app/shared/_services/device-location.service';
import { LatLng } from '@app/shared/_models/common.models';
import { UserPreferencesService } from '@app/shared/_services/user-preferences.service';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';






@Component({
  selector: 'app-location-list',
  standalone: true,
  imports: [CommonModule, NgxPaginationModule, RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './location-list.component.html',
  styleUrl: './location-list.component.css'
})
export class LocationListComponent implements OnInit {
  @ViewChild('locationContainer') loadContainer!: ElementRef;

  //pagination variables
  locations: any[] = [];
  currentPage: number = 1;
  pageSize: number = 15;
  count: number = 0; // Use consistent variable name for total items

  startDateMs!: string;
  endDateMs!: string;
  userID!: string;
  // count: number | undefined;
  lat!: number;
  lng!: number;
  zoom: number = 5;
  location: LatLng = { lat: 0, lng: 0 };

  selectedRowItem: any;

  @Output() locationsChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  private userPref = inject(UserPreferencesService);
  private deviceLocService = inject(DeviceLocationService);
  private route = inject(ActivatedRoute);
  private elementRef = inject(ElementRef);
  constructor() {
  

    this.zoom = this.userPref.getLastZoom();
    this.location = this.userPref.getLastLocation();
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.userID = params['userId'];
      this.setDefaultDateRange();
      this.fetchLocations();
    });
  }

  private setDefaultDateRange(): void {
    const currentDate = new Date();
    this.endDateMs = currentDate.getTime().toString();
    const yesterday = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000);
    this.startDateMs = yesterday.getTime().toString();
  }

  private calculateDistance(lat1: number, lon1:number, lat2:number, lon2:number): number {
    const R = 6371000; // Radius of the earth in meters
    const dLat = this.toRadians(lat2 - lat1);  // Convert degrees to radians
    const dLon = this.toRadians(lon2 - lon1);  // Convert degrees to radians

   
    const a = 
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.toRadians(lat1)) * Math.cos(this.toRadians(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    return distance;
  }

  private toRadians(degrees: number): number {
    return degrees * (Math.PI / 180);
  }

  private getCoordinates(location: any): { lat: number, lng: number } | null{
    if (!location) return null;
    
    const coords = location.location?.coordinates || location.location;
    const lat = location.latitude ?? (Array.isArray(coords) ? coords[1] : coords?.lat);
    const lng = location.longitude ?? (Array.isArray(coords) ? coords[0] : coords?.lng);
    if (typeof lat === 'number' && typeof lng === 'number') {
      return { lat, lng };
    }
    return null;

  }


  getDistanceFromPrevious(index: number): number | null {
    if (index === 0) {
      return null;
    }

    const currentLoc = this.locations[index];
    const previousLoc = this.locations[index - 1];

    const previousCoords = this.getCoordinates(previousLoc);
    const currentCoords = this.getCoordinates(currentLoc);

    if (!currentCoords || !previousCoords) {
      return null;
    }

    return this.calculateDistance(
      previousCoords.lat,
      previousCoords.lng,
      currentCoords.lat,
      currentCoords.lng
    )
  }

  formateDistance(distance: number | null): string {
    if (distance === null) {
      return 'N/A';
    }
      
    if (distance < 1000) {
      return `${distance.toFixed(0)} m`;
    } else {
      return `${(distance / 1000).toFixed(2)} km`;
    }
  }


  private updateLocations(result: any): void {
    this.locations = result?.data || [];
    this.count = result?.count || 0;
    this.locationsChange.emit(this.locations);
  }

  private fetchLocations(): void {
    if (!this.userID || !this.startDateMs || !this.endDateMs) {
      return;
    }

    this.deviceLocService
      .getUserLocationPaginate(
        this.startDateMs,
        this.endDateMs,
        this.userID,
        this.currentPage,
        this.pageSize
      )
      .subscribe(
        (result) => this.updateLocations(result),
        (err) => {
          console.log('deviceLocation error', err);
        }
      );
  }

  private toTimestamp(input: string): string | null {
    const parsed = new Date(input);
    if (isNaN(parsed.getTime())) {
      return null;
    }
    return parsed.getTime().toString();
  }

  loadLocationsByRange(startDateInput: string, endDateInput: string): void {
    const startMs = this.toTimestamp(startDateInput);
    const endMs = this.toTimestamp(endDateInput);

    if (!startMs || !endMs) {
      return;
    }

    if (parseInt(startMs, 10) > parseInt(endMs, 10)) {
      return;
    }

    this.startDateMs = startMs;
    this.endDateMs = endMs;
    this.currentPage = 1;
    this.fetchLocations();
  }

  onPageChanged(newPage: number) {
    const totalPages = Math.max(1, Math.ceil(this.count / this.pageSize));
    this.currentPage = Math.min(Math.max(newPage, 1), totalPages);
    this.fetchLocations();

    if (this.loadContainer) {
      this.loadContainer.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  showMarker(index: number): void {
    this.selectedRowItem = index;
    const location = this.locations[index];

    if (!location) {
      return;
    }

    const coords = location.location?.coordinates || location.location;
    const lat = location.latitude ?? (Array.isArray(coords) ? coords[1] : coords?.lat);
    const lng = location.longitude ?? (Array.isArray(coords) ? coords[0] : coords?.lng);

    if (typeof lat === 'number' && typeof lng === 'number') {
      this.lat = lat;
      this.lng = lng;
    }
  }

  onMarkerClicked(index :number) :void {
    this.selectedRowItem = index;
    this.scrollElementIntoView(index);
  }

  scrollElementIntoView(index :number) :void {
    const tableRow: HTMLInputElement = this.elementRef.nativeElement.querySelector(`#loc${index}`);
    if(tableRow) {
      tableRow.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    
  }
  
}
